import StoryblokMobileMenu from "./StoryblokMobileMenu";

export default StoryblokMobileMenu;
